import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkVersion } from './actions';
import VersionCheckerComponent from './components';
import { push } from '../../common/actions/navigate';

class VersionChecker extends Component {

    _reload = () => {
        window.location.reload(true);
    }

    _login = () => {
        this.props.dispatch(push('/login'));
    }

    componentWillReceiveProps({ version }) {
        if (version.refresh && !this.props.version.refresh) {
            this.props.checkVersion();
        }
    }

    render() {
        const { version } = this.props;
        return (
            <VersionCheckerComponent
                action={this._reload}
                version={version.data}/>
        );
    }
}

function bindAction(dispatch) {
    return {
        checkVersion: () => dispatch(checkVersion())
    };
}

function mapStateToProps(state) {
    return {
        version: state.version
    };
}

export default connect(mapStateToProps, bindAction)(VersionChecker);


